import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: "2%",
    marginRight: "2%",
    width: "95%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

export default function ListSkeleton({ numRows }) {
  const classes = useStyles();

  const rows = [];
  for (let i = 0; i < numRows; i++) {
    rows.push(<Skeleton animation="wave" key={i} height={50} />);
  }

  return <div className={classes.root}>{rows}</div>;
}
